export default "__VITE_ASSET__2b9c1b4b__"